import { PendingUser } from '@/lib/class/PendingUser'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const bootstrapUser = () => {
  const sessionUser = sessionStorage.getItem('registerUser')

  if (!sessionUser) {
    return {}
  }

  const parsedSessionUser = JSON.parse(sessionUser)

  return typeof parsedSessionUser === 'object'
    ? new PendingUser(parsedSessionUser)
    : {}
}

interface RegistrationState {
  customerId: string
  caregiversIds: Array<any>
  numberOfCaregivers: number
  caregiversCards: Array<any>
  serviceRequestDraftId: string
  email: string
  registerUser: PendingUser | object
  caregiversListByPostcode: {}
  customerLead: object
  reactivateCC: object
  newCustomer: object
  customerInfo: object
}

const state: RegistrationState = {
  customerId: '',
  caregiversIds: [],
  numberOfCaregivers: 0,
  caregiversCards: [],
  serviceRequestDraftId: '',
  email: '',
  registerUser: bootstrapUser(),
  customerLead: {
    firstName: '',
    lastName: '',
    phone: null,
    email: '',
    startDate: '',
    description: '',
    day: '',
    time: '',
    services: [],
    mainServices: '',
    secondaryServices: '',
    utmTerm: '',
    utmContent: '',
    utmMedium: '',
    utmSource: '',
    utmCampaign: '',
    utmCampaigns: '',
    gclid: '',
    zipCode: ''
  },
  reactivateCC: {
    ContactId: '',
    email: '',
    Lostreason: '',
    Improvements: '',
    Feedback: false,
    Comment: ''
  },
  newCustomer: {
   firstName: '',
   lastName: '',
   email: '',
   phone: null,
   postcode: null,
   company: '',
   city: '',
  },
  customerInfo: {
    salutation: '',
    dateOfBirth: null,
    address:'',
    residence: '',
    conduct: '',
    languageSkills:'',
    otherLanguageSkills: '',
    education: [],
    educationField: [],
    workStatus: [],
    workLocation: [],
    berlinOption: '',
    noBerlinOption1: '',
    noBerlinOption2: '',
    checkResident: false,

    workDuration: '',
    workMotivation: [],
    workRecommandation: '',
    wordRecruter: '',
  },
  caregiversListByPostcode: {
    caregivers: [],
    amount_total: 0,
    amount_male: 0,
    amount_female: 0,
  },
}

export default {
  namespaced: true,
  actions,
  mutations,
  getters,
  state,
}
